import React, { Component } from 'react';
import PropTypes from 'prop-types';
import uuidv4 from 'uuid/v4';

import { connect } from 'react-redux';

import { enterPassword } from 'actions/workflow';

import changeScreen from 'actions/router';

import {
  Display,
  Header,
  Content,
  Footer,
  HardwareButtonWrapper
} from 'containers';

import { HeaderText, DigitInput } from 'components';
import { DisplayButton } from 'components/buttons';

import styles from './Password.scss';

class Password extends Component {
  constructor() {
    super();

    this.password = 1982;
    this.limits = {
      min: 0,
      max: 9
    };

    this.state = {
      selectedIndex: 0,
      numbers: [0, 0, 0, 0],
      buttonConfig: {
        left: {
          onClick: this.incrementValue
        },
        center: {
          onClick: this.selectValue
        },
        right: {
          onClick: this.decrementValue
        }
      }
    };
  }

  incrementValue = () => {
    this.changeValue('increment');
  };

  decrementValue = () => {
    this.changeValue('decrement');
  }

  changeValue = (action) => {
    const { selectedIndex, numbers } = this.state;
    const currentVal = numbers[selectedIndex];
    let newVal;

    if (action === 'increment') {
      newVal = (currentVal + 1 > this.limits.max) ? this.limits.min : currentVal + 1;
    } else if (action === 'decrement') {
      newVal = (currentVal - 1 < this.limits.min) ? this.limits.max : currentVal - 1;
    }

    numbers[selectedIndex] = newVal;

    this.setState({
      numbers
    });
  }

  selectValue = () => {
    const { selectedIndex, numbers } = this.state;
    const { navigateTo, setPassword } = this.props;

    if (selectedIndex === numbers.length - 1) {
      const val = numbers.join('');
      let destination = 'default';

      if (val === this.password.toString()) {
        destination = 'settings';
        setPassword();
      }

      navigateTo(destination);
    } else {
      const newIndex = selectedIndex + 1;

      this.setState({
        selectedIndex: newIndex
      });
    }
  }

  render() {
    const { numbers, selectedIndex, buttonConfig } = this.state;
    const digits = numbers.map((item, i) =>
      (<DigitInput
        key={uuidv4()}
        value={item}
        selected={selectedIndex === i}
      />));

    return [
      <Display key="display">
        <Header>
          <HeaderText value="Enter password" />
        </Header>
        <Content>
          <div className={styles.digitWrapper}>
            <div className={styles.digits}>
              {digits}
            </div>
          </div>
        </Content>
        <Footer>
          <DisplayButton src="icon-xm-up-arrow" />
          <DisplayButton src="icon-xm-enter" />
          <DisplayButton src="icon-xm-down-arrow" />
        </Footer>
      </Display>,
      <HardwareButtonWrapper key="buttons" config={buttonConfig} />
    ];
  }
}

Password.propTypes = {
  navigateTo: PropTypes.func.isRequired,
  setPassword: PropTypes.func.isRequired
};

export default connect(null, {
  navigateTo: changeScreen,
  setPassword: enterPassword
})(Password);



// WEBPACK FOOTER //
// ./src/screens/shared/Password/Password.js